export const getClientIdFromServiceId = (serviceId: string): string => {
  return serviceId.startsWith("LSN") ? "LISSN" : serviceId.replace(/0+1$/, "");
};
